import { isAxiosNetworkError } from './errorHandler'

const DEFAULT_MAX_ATTEMPTS = 3
const DEFAULT_DELAYS_MS = [400, 1200]

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

/** Retry when the request likely never reached the app (or gateway blip). */
export const isRetryableAxiosFailure = (error) => {
    if (isAxiosNetworkError(error)) return true
    const status = error?.response?.status
    return status === 502 || status === 503 || status === 504
}

/**
 * @template T
 * @param {() => Promise<T>} requestFn
 * @param {{ maxAttempts?: number, delaysMs?: number[] }} [options]
 * @returns {Promise<T>}
 */
export const retryAxiosRequest = async (requestFn, options = {}) => {
    const maxAttempts = options.maxAttempts ?? DEFAULT_MAX_ATTEMPTS
    const delaysMs = options.delaysMs ?? DEFAULT_DELAYS_MS
    let lastError

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
            return await requestFn()
        } catch (error) {
            lastError = error
            if (attempt >= maxAttempts || !isRetryableAxiosFailure(error)) {
                throw error
            }
            const waitMs = delaysMs[attempt - 1] ?? delaysMs[delaysMs.length - 1] ?? 0
            if (waitMs > 0) {
                await delay(waitMs)
            }
        }
    }

    throw lastError
}
